import { createPortal } from "react-dom";

const Portal = ({ children, element = document.body }) =>
  element ? createPortal(children, element) : null;

export default Portal;
